import React from 'react'
import { Box } from '../Box/Box'
import { Dropdown } from '../Dropdown/Dropdown'
import { DropdownFlyout } from '../DropdownFlyout/DropdownFlyout'
import { MultiSelect } from '../MultiSelect/MultiSelect'
import { PillSelect } from '../PillSelect/PillSelect'

import { useId } from '@react-aria/utils'
import { Button } from '../Button'
import { Content } from '../Content'
import { Actions } from '../Content/Content'
import { Field } from '../Field'
import { Flex } from '../Flex'
import { Form } from '../Form'
import { Link } from '../Link'
import { Popover } from '../Popover'
import { Search } from '../Search/Search'
import { Select } from '../Select/Select'
import { H3, Label } from '../Semantic'
import { SuperSelect } from '../SuperSelect/SuperSelect'
import { TieredSelect } from '../TieredSelect/TieredSelect'
import { Tooltip } from '../Tooltip'
import { Typeahead } from '../Typeahead'

const idLabelOptions = [
  { id: 1, label: 'One' },
  { id: 2, label: 'Two' },
  { id: 3, label: 'Three' },
]

export function EscapefulFieldSet() {
  const [typeaheadV, setTyeahead] = React.useState('')
  const baseId = useId()

  return (
    <Content>
      <H3>Things with Esc key:</H3>
      <Field>
        <Label id={`${baseId}-search`}>Search</Label>
        <Search aria-labelledby={`${baseId}-search`} />
      </Field>
      <Field>
        <Label id={`${baseId}-typeahead`}>Typeahead</Label>
        <Typeahead
          value={typeaheadV}
          onChange={setTyeahead}
          aria-labelledby={`${baseId}-typeahead`}
        />
      </Field>
      <Field>
        <Label id={`${baseId}-select`}>Select</Label>
        <Flex gap="sm">
          <Box id="s-default">Default</Box>
          <Select aria-labelledby={`${baseId}-select s-default`}>
            {idLabelOptions.map(({ id, label }) => (
              <Select.Option key={id} value={id}>
                {label}
              </Select.Option>
            ))}
          </Select>
          <Box id="s-search">Search</Box>
          <Select
            onSearch={console.log}
            aria-labelledby={`${baseId}-select s-search`}
          >
            {idLabelOptions.map(({ id, label }) => (
              <Select.Option key={id} value={id}>
                {label}
              </Select.Option>
            ))}{' '}
          </Select>
        </Flex>
      </Field>
      <Field>
        <Label id={`${baseId}-pillselect`}>PillSelect</Label>
        <Flex gap="sm">
          <Box id="p-default">Default</Box>
          <PillSelect
            options={idLabelOptions}
            onChange={console.log}
            value={null}
            aria-labelledby={`${baseId}-pillselect p-default`}
          />
          <Box id="p-search">Search</Box>
          <PillSelect
            options={idLabelOptions}
            onChange={console.log}
            onSearch={console.log}
            value={null}
            aria-labelledby={`${baseId}-pillselect p-search`}
          />
        </Flex>
      </Field>
      <Field>
        <Label id={`${baseId}-multiselect`}>MultiSelect</Label>
        <MultiSelect
          options={idLabelOptions}
          aria-labelledby={`${baseId}-multiselect`}
        />
      </Field>
      <Field>
        <Label id={`${baseId}-dropdown`}>Dropdown</Label>
        <Flex gap="sm" wrap="wrap">
          <Box>Default</Box>
          <Dropdown aria-labelledby={`${baseId}-dropdown`}>
            {idLabelOptions.map(({ id, label }) => (
              <Dropdown.Item key={id} item={id}>
                {label}
              </Dropdown.Item>
            ))}
          </Dropdown>
          <Box>Search</Box>
          <Dropdown
            onSearch={console.log}
            aria-labelledby={`${baseId}-dropdown`}
          >
            {idLabelOptions.map(({ id, label }) => (
              <Dropdown.Item key={id} item={id}>
                {label}
              </Dropdown.Item>
            ))}
          </Dropdown>
          <Box>Restore</Box>
          <Dropdown restoreFocusOnHide aria-labelledby={`${baseId}-dropdown`}>
            {idLabelOptions.map(({ id, label }) => (
              <Dropdown.Item key={id} item={id}>
                {label}
              </Dropdown.Item>
            ))}
          </Dropdown>
          <Box>Restore w/ search</Box>
          <Dropdown
            onSearch={console.log}
            restoreFocusOnHide
            aria-labelledby={`${baseId}-dropdown`}
          >
            {idLabelOptions.map(({ id, label }) => (
              <Dropdown.Item key={id} item={id}>
                {label}
              </Dropdown.Item>
            ))}
          </Dropdown>
          <Box>DropdownFlyout</Box>
          <DropdownFlyout
            style={{ display: 'inline-block' }}
            options={[
              { value: 1, label: 'wow' },
              {
                value: 'Animals',
                label: 'Long complicated label that takes space',
                children: [
                  {
                    value: 'Amphibians',
                    label: 'Amphibians',
                    children: [
                      { value: 1, label: 'Frogs' },
                      { value: 2, label: 'Salamanders' },
                    ],
                  },
                  {
                    value: 'Birds',
                    label: 'Long complicated label that takes space',
                    children: [
                      { value: 3, label: 'Chickens' },
                      { value: 4, label: 'Falcons' },
                      { value: 5, label: 'Owls' },
                      { value: 6, label: 'Parrots' },
                    ],
                  },
                ],
              },
            ]}
            aria-labelledby={`${baseId}-dropdown`}
          />
        </Flex>
      </Field>
      <Field>
        <Label id={`${baseId}-tiered`}>Tiered</Label>
        <TieredSelect
          options={[
            {
              id: 1,
              groupId: null,
              nextGroupId: 10,
              label: 'Apple Farm',
              disabled: true,
            },
            {
              id: 17,
              groupId: 10,
              nextGroupId: 100,
              label: 'Granny Smith',
            },
            {
              id: 2,
              groupId: null,
              nextGroupId: 20,
              label: "Tim's Trees",
            },
          ]}
          aria-labelledby={`${baseId}-tiered`}
        />
      </Field>
      <Field>
        <Label id={`${baseId}-tiered-leaf`}>Tiered leaf only</Label>
        <TieredSelect
          selectableTiers={false}
          options={[
            {
              id: 1,
              groupId: null,
              nextGroupId: 10,
              label: 'Apple Farm',
              disabled: true,
            },
            {
              id: 17,
              groupId: 10,
              nextGroupId: 100,
              label: 'Granny Smith',
            },
            {
              id: 2,
              groupId: null,
              nextGroupId: 20,
              label: "Tim's Trees",
            },
          ]}
          aria-labelledby={`${baseId}-tiered-leaf`}
        />
      </Field>
      <Field>
        <Label id={`${baseId}-superselect`}>SuperSelect</Label>
        <SuperSelect
          onChange={console.log}
          options={[
            { value: '1', label: 'some label one' },
            { value: '2', label: 'two 2' },
            { value: '3', label: 'three three three' },
          ]}
          emptyMessage="E m p t y"
          aria-labelledby={`${baseId}-superselect`}
        />
      </Field>
    </Content>
  )
}

function PopupSet({ alignLeft = true }) {
  const baseId = useId()
  const id = {
    pop1: baseId + 'pop1',
    pop2: baseId + 'pop2',
  }
  return (
    <Actions
      style={{
        // TODO new prop. sometimes left actions could make sense
        justifyContent: alignLeft ? 'flex-start' : undefined,
        // why not, different sizes (Switch) just align them
        alignItems: 'center',
      }}
    >
      <Tooltip
        overlay="Tooltip popup here, checks out."
        role="tooltip"
        trigger={['focus', 'hover']}
      >
        <Button variant="secondary" onClick={alert.bind(null, 'CORE')}>
          Tooltip!
        </Button>
      </Tooltip>
      <Tooltip
        overlay="Long name never gonna give you up.mp4"
        role="tooltip"
        trigger={['focus', 'hover']}
      >
        <Link href="#">Long name....up.mp4</Link>
      </Tooltip>
      <Popover
        aria-labelledby={id.pop1}
        restoreFocusOnHide
        role="dialog"
        overlay={
          <Popover.Content>
            <Box padding="sm">
              Popover popup here, check out this{' '}
              <Link href="https://app.procore.com">app link</Link> and{' '}
              <Link href="https://login.procore.com">login link</Link>.
            </Box>
          </Popover.Content>
        }
        trigger={['click']}
      >
        <Button aria-haspopup="dialog" id={id.pop1} variant="secondary">
          Click to Popup!
        </Button>
      </Popover>
      {/* <Popover
        aria-labelledby={id.pop2}
        restoreFocusOnHide
        role="dialog"
        overlay={
          <Popover.Content>
            <Box padding="sm">
              Popover popup here, check out this{' '}
              <Link href="app.procore.com">app link</Link> and{' '}
              <Link href="login.procore.com">login link</Link>.
            </Box>
          </Popover.Content>
        }
        trigger={['hover', 'focus']}
      >
        <Link aria-haspopup="dialog" id={id.pop2} href="#">
          Hover Popup
        </Link>
      </Popover> */}
    </Actions>
  )
}

export function UserInteractionSet() {
  return (
    <Content>
      <PopupSet />
      <Form
        enableConfirmNavigation
        initialValues={{
          rtf: '<b>Clicking the TinyMCE option to add a link should open a modal, and that modal should be able to receive focus.</b>',
        }}
      >
        <Form.Row>
          <Form.DateSelect
            colWidth={12}
            description="Form Field with misc interactions"
            label="Form Component Field"
            name="f_1"
            tooltip="Tooltip popup here, checks out."
          />
        </Form.Row>
        {/* <Form.Row>
          <Form.RichText
            colWidth={12}
            description="Has links tinymce modal. This destroys contained focus :("
            label="Form Rich Text"
            name="rtf"
            plugins={['link', 'image']}
          />
        </Form.Row> */}
      </Form>
      <EscapefulFieldSet />
    </Content>
  )
}
